import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import EndorLabsCredentialsForm from './EndorLabsCredentialsForm';
import EndorLabsConfigListing from './EndorLabsConfigListing';

const EndorLabsPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={EndorLabsCredentialsForm}
        PullConfigListingView={EndorLabsConfigListing}
     />
);

export default EndorLabsPullAndPushView;
